// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './js/check';
import 'babel-polyfill';
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
import './js/common';
import './js/util';
import './js/http';
import './js/vlidator';
import moment from 'moment';
import 'moment/locale/zh-cn';
import Antd, { message } from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import VueAMap from 'vue-amap';
import UIPackage from './package';
import wangEditor from 'wangeditor';
import xss from 'xss';
import './themes/minireset.css';
import './themes/variable.scss';
import './themes/common.scss';
import './themes/modules.scss';

import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

import Highcharts from 'highcharts/highstock';
import HighchartsMore from 'highcharts/highcharts-more';
import HighchartsDrilldown from 'highcharts/modules/drilldown';
import Highcharts3D from 'highcharts/highcharts-3d';
import variablePie from 'highcharts/modules/variable-pie';

import chartOptions from './js/chartOptions';
import './themes/dataVisual/common.scss';
import './themes/dataVisual/variable.scss';
import './themes/dataVisual/modules.scss';
import './themes/dataVisual/iconfont/iconfont.css';
import './themes/dataVisual/font/custom.css';

moment.locale('zh-cn');

Vue.use(Antd);
Vue.use(UIPackage);
Vue.use(VueAMap);
HighchartsMore(Highcharts);
HighchartsDrilldown(Highcharts);
Highcharts3D(Highcharts);
variablePie(Highcharts);
Highcharts.setOptions(chartOptions.setOptions);

message.config({ duration: 1, maxCount: 1 });

VueAMap.initAMapApiLoader({
  key: 'your amap key',
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.4'
});

Vue.prototype.Xss = xss;
Vue.prototype.WangEditor = wangEditor;
Vue.prototype.VueAMap = VueAMap;
Vue.prototype.Moment = moment;
Vue.prototype.Highcharts = Highcharts;

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js